<template>
  <section class="section-panel room-tables photo-wall" :key="$route.params.roomSlug">
    <ev-tabs :options="{ tabClass: '' }">
      <span class="hide-full-size" @click="hideFullSize()">✖</span>
      <ev-tab v-show="showPhotoWall" name="Photo wall">
        <photo-wall-tab :cols="cols" :edit="false"></photo-wall-tab>
      </ev-tab>
      <ev-tab v-show="showPhotoWall" name="My posts">
        <photo-wall-tab isMyPosts :cols="cols"></photo-wall-tab>
      </ev-tab>
      <template v-slot:actions>
        <div class="actions">
          <button id="ev-post-image-button" class="post-image" @click="openModal()">Post image</button>
          <i
            class="fa fa-question-circle"
            v-tooltip="{
              content:
                'Post your own image to the Photo Wall and optionally ' +
                'also send the update directly to your Twitter feed.',
              placement: 'bottom-center'
            }"
          ></i>
          <i
            class="ar-icon icon-pw-black-sm active"
            aria-hidden="true"
            data-size="50vh"
            @click="changeSize($event)"
          ></i>
          <i class="ar-icon icon-pw-black-md" aria-hidden="true" data-size="60vh" @click="changeSize($event)"></i>
          <i class="ar-icon icon-pw-black-lg" aria-hidden="true" data-size="90vh" @click="changeSize($event)"></i>
          <i class="ar-icon icon-pw-black-fs" aria-hidden="true" data-size="full" @click="changeSize($event)"></i>
          <i class="fa" :class="showPhotoWall ? 'fa-chevron-down' : 'fa-chevron-up'" @click="showHideWall()"></i>
        </div>
      </template>
    </ev-tabs>
    <photo-wall-modal></photo-wall-modal>
  </section>
</template>

<script>
import Tabs from "@/components/DigitalEvent/common/Tabs";
import Tab from "@/components/DigitalEvent/common/Tab";
import PhotoWallModal from "./PhotoWallModal.vue";
import PhotoWallTab from "./PhotoWallTab.vue";
import { mapState } from "vuex";

export default {
  name: "PhotoWall",
  components: {
    "ev-tabs": Tabs,
    "ev-tab": Tab,
    "photo-wall-modal": PhotoWallModal,
    "photo-wall-tab": PhotoWallTab
  },
  data() {
    return {
      photoWall: null,
      cols: { default: 10, 2000: 9, 1800: 8, 1600: 7, 1400: 6, 1200: 5, 1000: 4, 800: 3, 600: 2, 400: 1 },
      cashSize: "50vh",
      showPhotoWall: true
    };
  },
  computed: {
    ...mapState({
      posts: state => state.photoWall.posts
    }),
    photoWallElement() {
      return document.querySelector(".photo-wall .tabs-component-panels");
    }
  },
  methods: {
    openModal() {
      this.$modal.show("photo-wall-modal");
    },
    changeSize(event) {
      let size = event.target.dataset.size;
      this.setActiveIcon(event.target);

      if (size !== "full") {
        this.photoWallElement.style.height = size;
        this.cashSize = size;
      } else {
        this.photoWallElement.classList.add("fixed");
        document.body.style.overflow = "hidden"; // prevent scroll if photo wall is fixed
      }
      this.showPhotoWall = true;
    },
    setActiveIcon(target) {
      const icons = document.querySelectorAll(".photo-wall .actions .ar-icon");
      icons.forEach(icon => {
        icon.classList.remove("active");
      });
      if (target) {
        target.classList.add("active");
      } else {
        let cachedIcon = [...icons].find(icon => icon.dataset.size === this.cashSize);
        cachedIcon.classList.add("active");
      }
    },
    hideFullSize() {
      this.photoWallElement.classList.remove("fixed");
      document.body.style.overflow = "auto"; // remove prevent scroll if photo wall is fixed
      this.setActiveIcon();
    },
    showHideWall() {
      this.showPhotoWall = !this.showPhotoWall;
      if (!this.showPhotoWall) {
        this.photoWallElement.style.height = 0;
        this.photoWallElement.style.minHeight = 0;
      } else {
        this.photoWallElement.style.height = this.cashSize;
        this.photoWallElement.style.minHeight = "500px";
      }
    }
  }
};
</script>

<style></style>
